import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import Badge from "@mui/material/Badge";

import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CloseIcon from "@mui/icons-material/Close";

import { getItem } from "../exportQuestions";
import { useIsIFrameLoaded } from "./useIFrameLoaded";
import { makeItemId } from "../../tools";

/* m-Path pulse
const StyledBadge = withStyles((theme) => ({
  badge: {
    width: 130,
    height: 130,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.light,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "3px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge); */

const height = "880px";
const width = "500px";
const zoom = 0.7;

export default function PhonePreview({
  questionTree,
  selected,
  details,
  handleQuestionTreeApi,
}) {
  const [openPreview, setOpenPreview] = useState(false);
  const handlePreview = () => {
    setOpenPreview((prev) => {
      handleQuestionTreeApi({ type: "SHIFT_TO_LEFT", payload: !prev });
      return !prev;
    });
  };
  const [questionList, setQuestionList] = useState("");
  const [selectedKey, setSelectedKey] = useState("");
  const [iFrameId, setIFrameId] = useState(makeItemId());
  useEffect(() => {
    if (!openPreview) return;
    const key = selected.split("#")[0];
    if (
      JSON.stringify(questionTree.getItem("root")) !==
        JSON.stringify(questionList) ||
      JSON.stringify(key) !== JSON.stringify(selectedKey)
    ) {
      const question = questionTree.getItem(key)?.value ?? {};
      const exportQuestion = getItem(question); //const questionList = exportQuestions(question, )
      const questionJSON = JSON.stringify(exportQuestion);
      const questionListName = details.fullQuestion;
      const namePractitioner = "";
      localStorage.setItem("question", questionJSON);
      localStorage.setItem("nameQuestionnaire", questionListName);
      localStorage.setItem("namePractitioner", namePractitioner);
      localStorage.setItem("isApplet", 0); // interactionType === 2
      //ref?.current?.contentWindow?.location?.reload(); // alternative solutation for rerendering the iFrame
      setIFrameId(makeItemId); // rerender the iFrame
    }
    setQuestionList(questionTree.getItem("root"));
    setSelectedKey(key);
  }, [selected, questionTree, openPreview]);
  return (
    <div>
      <Tooltip title={"Preview"}>
        {/* wrapper element because we are providing a disabled `button` child to the Tooltip component */}
        <span>
          <IconButton
            aria-label="Preview question"
            onClick={handlePreview}
            size="large"
            disabled={["", "title"].includes(selected)}
          >
            <VisibilityOutlinedIcon />
          </IconButton>
        </span>
      </Tooltip>
      {openPreview ? (
        <Box position={"fixed"} top={84} left="auto" right={24}>
          <Box position={"absolute"} top={0} width="100%" height="100px">
            {/* Notch phone */}
            <Box
              width="18vh"
              height={20}
              margin="0 auto"
              backgroundColor="#111"
              sx={{
                borderBottomLeftRadius: "2.334vh",
                borderBottomRightRadius: "2.334vh",
              }}
            />
          </Box>
          <IconButton
            sx={{ position: "absolute", top: "8px", right: "16px" }}
            aria-label="close"
            onClick={handlePreview}
            size="large"
          >
            <CloseIcon />
          </IconButton>
          <Box
            style={{
              border: "8px solid #111",
              borderRadius: "4.5vh",
              height: height,
              width: width,
              zoom: zoom,
            }}
            backgroundColor="#fafafa"
            display="flex"
            textAlign="center"
            alignItems="center"
            justifyContent="center"
            position="absolute"
            zIndex={-11}
          >
            <CircularProgress style={{ zoom: 1 + (1 - zoom) }} />
          </Box>
          <iframe
            key={iFrameId}
            src={`${window.REACT_APP_EMULATOR_PATH}?${iFrameId}`}
            style={{
              display: "block",
              border: "8px solid #111",
              borderRadius: "4.5vh",
              height: height,
              width: width,
              zoom: zoom,
            }}
            sandbox
          >
            <CircularProgress style={{ zoom: 1 + (1 - zoom) }} />
          </iframe>
        </Box>
      ) : null}
    </div>
  );
}
